import { useState } from "react";
import { Link } from "react-router-dom";
import { Dices, Clapperboard, Check, Cat, Dog, Bot, Bird, Ghost, Rabbit, Castle, Trees, Mountain, Waves, Moon, School, Crown, Key, Gift, Umbrella, Pizza, IceCreamCone } from "lucide-react";

const FACES = [
  [["a cat", Cat], ["a puppy", Dog], ["a robot", Bot], ["a parrot", Bird], ["a friendly ghost", Ghost], ["a bunny", Rabbit]],
  [["in a castle", Castle], ["in the forest", Trees], ["on a mountain", Mountain], ["at the beach", Waves], ["on the moon", Moon], ["at a magic school", School]],
  [["finds a crown", Crown], ["finds a secret key", Key], ["opens a gift", Gift], ["loses an umbrella", Umbrella], ["bakes a giant pizza", Pizza], ["shares ice cream", IceCreamCone]],
];
const COLORS = ["#FF8FC7", "#3DCCC7", "#FFD23F"];
const roll = () => FACES.map((f) => Math.floor(Math.random() * f.length));

export const StoryDice = ({ onFinish }) => {
  const [dice, setDice] = useState(roll);
  const [spin, setSpin] = useState(false);
  const [rolls, setRolls] = useState(0);
  const story = dice.map((d, i) => FACES[i][d][0]).join(" ");

  const doRoll = () => {
    setSpin(true);
    setTimeout(() => { setDice(roll()); setSpin(false); setRolls((r) => r + 1); }, 450);
  };

  return (
    <div className="max-w-2xl mx-auto text-center space-y-6">
      <div className="grid grid-cols-3 gap-3 sm:gap-5">
        {dice.map((d, i) => {
          const [label, Icon] = FACES[i][d];
          return (
            <div key={i} data-testid={`dice-${i}`} className={`aspect-square rounded-3xl border-[3px] border-[#1B1A2E] shadow-[4px_4px_0_0_#1B1A2E] grid place-items-center p-2 transition-transform duration-300 ${spin ? "rotate-[200deg] scale-90" : ""}`} style={{ background: COLORS[i] }}>
              <div><Icon className="mx-auto w-10 h-10 sm:w-16 sm:h-16" strokeWidth={2.2} /><p className="font-display text-xs sm:text-base font-semibold mt-1 leading-tight">{label}</p></div>
            </div>
          );
        })}
      </div>
      <p data-testid="dice-story" className="zn-card bg-white p-4 font-display text-xl sm:text-2xl font-semibold">Once upon a time, {story}…</p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <button data-testid="dice-roll-btn" onClick={doRoll} disabled={spin} className="zn-btn bg-[#7B5CFA] text-white"><Dices size={20} /> Roll the dice</button>
        <Link to={`/kid/studio?title=${encodeURIComponent(`Story: ${story}`.slice(0, 80))}`} data-testid="dice-film-btn" className="zn-btn bg-[#FFD23F]"><Clapperboard size={18} /> Film this story</Link>
        <button data-testid="dice-done-btn" disabled={rolls < 1} onClick={() => onFinish(rolls, Math.min(3, rolls))} className="zn-btn bg-white"><Check size={18} /> I told my story!</button>
      </div>
      <p className="text-sm text-[#1B1A2E]/60">Roll, then tell the story out loud to someone at home!</p>
    </div>
  );
};
